module.exports = __webpack_public_path__ + "static/media/jasmine.359fc809.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/jasmine.png
// module id = 122
// module chunks = 0